import React from "react";
import TabSlider from "../../common/TabSlider";
import { SlotTabData } from "../../helper/Helper";
import { FishingIcon } from "../../helper/Icon2";
import SwiperSlider from "../../common/SwiperSlider";

function FishingTabContent() {
  return (
    <>
      <SwiperSlider
        sectionHeading={"Fishing"}
        icon={<FishingIcon />}
        data={SlotTabData}
      />
    </>
  );
}

export default FishingTabContent;
